import React, { useRef, useState, useEffect } from 'react';
import URL2 from '../../config';
import classes from './Topheader.module.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Container, Grid } from '@mui/material';
import ButtonWithIcon from '../ButtonWithIcon/ButtonWithIcon';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import { useDispatch } from 'react-redux';
import { logoutUser } from '../../utils/persistUtils';

const Topheader = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      {/* Main Site Header */}
      <Box className={`${classes.headerBox}`} sx={{ py: 1, bgcolor: '#FFFFFF', borderBottom: '1px solid #E2E8F0' }}>
        <Container maxWidth="xl">
          <div className={`${classes.headerOuter}`}>
            <Grid container alignItems="center">
              <Grid item xs={3}></Grid>

              <Grid textAlign={'center'} item xs={6}>
                <div className={`${classes.logoContainer}`}>
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/logo.png`}
                    alt="AIC Logo"
                    className={`${classes.logoimg}`}
                    style={{ maxHeight: '70px', width: 'auto' }}
                  />
                </div>
              </Grid>

              <Grid item xs={3} className={`${classes.topright}`}>
                <ButtonWithIcon
                  startIcon={<MenuIcon />}
                  onClick={toggleDropdown}
                  sx={{ borderRadius: '8px', minWidth: '40px' }}
                />
              </Grid>
            </Grid>
          </div>
        </Container>
      </Box>

      {/* Logout Dropdown Menu */}
      {isOpen && (
        <Box
          ref={dropdownRef}
          className={`${classes.dropdownMenu}`}
          sx={{
            position: 'absolute',
            zIndex: 1300,
            bgcolor: '#FFFFFF',
            borderRadius: '12px',
            boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
            p: 1,
            top: { xs: 110, sm: 120 },
            right: { xs: 16, sm: 32 }
          }}
        >
          <ButtonWithIcon
            startIcon={<LogoutIcon />}
            onClick={() => {
              // The whole session: the in-memory answers as well as the browser's copy. Clearing
              // only localStorage left the store holding the last family, and redux-persist wrote
              // it straight back — so the next family to sign in could see it.
              logoutUser(dispatch, navigate);
            }}
            text={'Logout'}
          />
        </Box>
      )}

    </>
  );
};

export default Topheader;